import React from "react";
// import s from "./ProgressBar.module.css"

const NoMatch = (props) => {

  return (
    <div >
      ERROR PAGE
    </div>
  )
}

export default NoMatch;